import * as React from "react";
import MuiTextField, {
  TextFieldProps
} from "@material-ui/core/TextField/TextField";
import { createStyles, Theme, withStyles } from "@material-ui/core";
import { Classes } from "jss";

type Props = TextFieldProps & {
  characterCounter?: boolean;
  classes: Classes;
  id?: string;
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      textAlign: "right",
      marginBottom: theme.spacing(1.5)
    }
  });

class TextField extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e: any) {
    this.props.onChange && this.props.onChange(e);
  }

  render() {
    const { characterCounter, classes, inputProps, id, value } = this.props;
    const maxCharacterLength = inputProps && inputProps.maxLength;
    const showCharacterCounter = characterCounter && maxCharacterLength;
    const count = String(value).length;
    // Prevent attempting to assign non-MUI props to component
    const props = { ...this.props };
    delete props.characterCounter;

    return (
      <MuiTextField
        {...props}
        FormHelperTextProps={{
          classes: {
            root: classes.root
          }
        }}
        data-test-control={id}
        helperText={showCharacterCounter && `${count} / ${maxCharacterLength}`}
        onChange={this.onChange}
      />
    );
  }
}

const styled = withStyles(styles)(TextField);
export { styled as TextField };
